import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnfrageService } from '@/api/service-index';
import { AnfrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AbschnittDisplayModel, GlobalEnumerationsAceFormulartyp, GlobalEnumerationsAceTypphase, GlobalEnumerationsAceTypprojektbericht, ProjektberichtDisplayModel } from '@/api/model-index';

@Injectable({
  providedIn: 'root'
})
export class GetAnfrageReportByIdResolver  {
  constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AnfrageDisplayModel | undefined> {
    let id: string = <string>route.params['id'];
    let reportid: string = <string>route.params['reportid'];

    if (this.portalContextService.CurrentAnfrage?.id == id && this.portalContextService.Berichte) {
      let currentBericht = this.portalContextService.Berichte.find(bericht => bericht.projektberichtId == reportid);
      if (currentBericht)
        this.setCurrentReport(currentBericht);

      return of(this.portalContextService.CurrentAnfrage);
    }

    let obsProjektberichte = this.anfrageService.apiAnfrageAnfrageIdBerichtGet({ anfrageId: id }).pipe(map(projektberichte => {
      return projektberichte;
    }));

    let obsAnfrage = this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: id }).pipe(map(response => {
      return response;
    }));

    return forkJoin({
      projektberichteWithAbschnitte: obsProjektberichte,
      anfrage: obsAnfrage
    }).pipe(map(value => {
      let parentAbschnnitt: AbschnittDisplayModel[] = [];

      if (!value.projektberichteWithAbschnitte.projektberichte) {
        return
      }

      value.projektberichteWithAbschnitte.projektberichte.forEach(bericht => {
        let abschnitt = new AbschnittDisplayModel();

        abschnitt.id = bericht.projektberichtId;

        let copiedAbschnitte: AbschnittDisplayModel[] = [];

        if (value.anfrage?.phase?.typ == GlobalEnumerationsAceTypphase.Bericht) {
          copiedAbschnitte = JSON.parse(JSON.stringify(value.anfrage?.phase?.abschnitte));
        }
        else if (value.anfrage?.phase?.typ == GlobalEnumerationsAceTypphase.Abschluss) {
          if (bericht.typ == GlobalEnumerationsAceTypprojektbericht.Zwischenbericht) {
            copiedAbschnitte = JSON.parse(JSON.stringify(value.projektberichteWithAbschnitte.abschnitteZwischenbericht));
          }
          else if (bericht.typ == GlobalEnumerationsAceTypprojektbericht.Abschlussbericht) {
            copiedAbschnitte = JSON.parse(JSON.stringify(value.anfrage?.phase?.abschnitte));
          }
        }

        copiedAbschnitte.forEach(abschnitt => abschnitt.parentId = bericht.projektberichtId)
        abschnitt.name = "";
        abschnitt.abschnitte = copiedAbschnitte;
        abschnitt.fragen = [];
        abschnitt.infotext = [];
        abschnitt.kurzTitel = [];
        abschnitt.reihenfolge = 0;
        abschnitt.formularTyp = GlobalEnumerationsAceFormulartyp.Fragen;
        parentAbschnnitt.push(abschnitt);
      })


      if (value.anfrage && value.anfrage.phase && value.anfrage.phase.abschnitte) {
        value.anfrage.phase.abschnitte = parentAbschnnitt;
        this.setCurrentAnfrage(value.anfrage);
      }

      //set projektberichte
      this.portalContextService.Berichte = value.projektberichteWithAbschnitte.projektberichte;
      let currentBericht = value.projektberichteWithAbschnitte.projektberichte.find(bericht => bericht.projektberichtId == reportid);
      if (currentBericht)
        this.setCurrentReport(currentBericht);

      return value.anfrage;
    }))
  }

  public setCurrentAnfrage(anfrage: AnfrageDisplayModel): void {
    this.portalContextService.CurrentAnfrage = anfrage;
  }

  public setCurrentReport(report: ProjektberichtDisplayModel): void {
    this.portalContextService.CurrentBericht = report;
  }
}
